import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyUtilsService } from '../../../services/formly/formly-utils.service';
import { Subject, debounceTime, filter, startWith, takeUntil } from 'rxjs';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';

@Component({
  standalone: false,
  selector: 'irembogov-custom-phone-number',
  templateUrl: './custom-phone-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomPhoneNumberComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  countryCodeFromPhone: string | undefined;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly formlyUtilsService: FormlyUtilsService,
    private readonly cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupCountryCodePrefill();
  }

  intelInputInitialized(status: 'success' | 'failed'): void {
    const initializedStatus = status === 'success' ? true : false;
    this.formlyUtilsService.onPhoneNumberFieldInitialized({
      key: <string>this.field.key,
      success: initializedStatus,
    });
  }

  private setupCountryCodePrefill(): void {
    const sourceFieldKey = this.field.props?.['prefillCountryCodeFrom'];
    if (!sourceFieldKey) return;

    this.field.options?.fieldChanges
      ?.pipe(
        filter(
          (e: FormlyValueChangeEvent) =>
            (e.type === 'valueChanges' || e.type === 'expressionChanges') &&
            e.field.key === sourceFieldKey
        ),
        startWith(null),
        debounceTime(300),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        const sourceValue = this.field.model?.[sourceFieldKey];
        if (sourceValue && sourceValue !== this.countryCodeFromPhone) {
          this.countryCodeFromPhone = sourceValue;
          this.cd.markForCheck();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
